<template>
  <div class="tw-bg-white tw-opacity-90 tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full">
    <slot></slot>
  </div>
</template>

<script>

  export default {
    name: 'FabricModalBackdrop',
  }
</script>
